import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { useIsAssistantAvailable } from '@/hooks/useIsAssistantAvailable';
import { useOptionalAssistantPanel } from './assistantPanelContext';

interface AssistantAskButtonProps {
  subject: string;
  question: string;
}

export function AssistantAskButton({ subject, question }: AssistantAskButtonProps) {
  const { t } = useTranslation('assistant');
  const isAvailable = useIsAssistantAvailable();
  const panel = useOptionalAssistantPanel();
  if (isAvailable === false || panel === null) {
    return null;
  }
  return (
    <button
      type="button"
      onClick={function askAboutSubject() {
        panel.askAbout(subject, question);
      }}
      className="px-2.5 py-1 text-[11px] rounded-lg font-semibold bg-zoovpalelavender text-zooprimary hover:bg-zoopalelavender flex items-center gap-1 shrink-0"
    >
      <Icon name="Sparkles" />
      {t('askAbout.button')}
    </button>
  );
}
